import styled from 'styled-components';

const ProblemSectionWrapper = styled.section`
  padding: 100px 0;
  background: #fff;

  @media (max-width: 767px) {
    padding: 60px 0;
  }

  .problem-content {
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
  }

  h2 {
    font-size: 42px;
    font-weight: 300;
    color: #1a1a2e;
    letter-spacing: -0.025em;
    line-height: 1.2;
    margin-bottom: 30px;

    @media (max-width: 991px) {
      font-size: 36px;
    }
    @media (max-width: 575px) {
      font-size: 28px;
    }
  }

  .lead {
    font-size: 19px;
    line-height: 1.8;
    color: #555;
    font-weight: 300;
    margin-bottom: 50px;

    @media (max-width: 575px) {
      font-size: 16px;
    }
  }

  .problems-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
    margin-bottom: 50px;

    @media (max-width: 575px) {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }

  .problem-item {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 24px 28px;
    background: #f8f9fa;
    border-radius: 12px;
    border: 1px solid #eee;
    text-align: left;
    transition: all 0.3s ease;

    &:hover {
      border-color: rgba(241, 102, 0, 0.2);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
      transform: translateY(-2px);
    }

    .problem-icon {
      flex-shrink: 0;
      color: #f16600;
    }

    p {
      font-size: 16px;
      color: #333;
      line-height: 1.5;
      margin: 0;
      font-weight: 400;
    }
  }

  .bridge-statement {
    padding: 35px 40px;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    border-radius: 0;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #f16600, #ff8534, #f16600);
      border-radius: 16px 16px 0 0;
    }

    p {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.7;
      margin: 0;
      font-weight: 300;

      @media (max-width: 575px) {
        font-size: 16px;
      }
    }

    @media (max-width: 575px) {
      padding: 25px;
    }
  }
`;

export default ProblemSectionWrapper;
